// What a store calls its reward points. The default is "CFAdollars"; a store
// that came from another system may already call them "Moola" or "Bucks".
// Display only: the balance field stays `cfaDollars` and the API shape is
// unchanged, only the words people read move.
// Mirror of server/src/utils/rewardsCurrency.js; keep the two in sync.

export const DEFAULT_CURRENCY_NAME = 'CFAdollars'
export const CURRENCY_NAME_MAX = 20

export function resolveCurrencyName(settings: any): string {
  const name = settings?.rewardsConfig?.currencyName
  return typeof name === 'string' && name.trim() ? name.trim() : DEFAULT_CURRENCY_NAME
}

/**
 * Rewrite free text (nav labels, help guides, tour copy) into the store's
 * wording. A no-op for default stores, so their copy is byte-for-byte unchanged.
 */
export function applyCurrencyName(text: string, name: string): string {
  if (!text || !name || name === DEFAULT_CURRENCY_NAME) return text
  return text.replace(/\bCFAdollars\b/g, name).replace(/\bCFA dollars\b/gi, name)
}
